import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface UpdateConfigPayload {
  appId: string;
  searchKey: string;
}

const FALLBACK_ALGOLIA_CREDENTIAL = 'unavailable';

export const algoliaSlice = createSlice({
  name: 'algolia',
  initialState: {
    appId: FALLBACK_ALGOLIA_CREDENTIAL,
    searchKey: FALLBACK_ALGOLIA_CREDENTIAL,
  },
  reducers: {
    updateAlgoliaConfig: (state, action: PayloadAction<UpdateConfigPayload>) => ({
      ...state,
      appId: action.payload.appId,
      searchKey: action.payload.searchKey,
    }),
  },
});

export const { updateAlgoliaConfig } = algoliaSlice.actions;

export default algoliaSlice.reducer;
